/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/filters/invOnHand.ts" />

module Meevo.Plugins.InventoryTransfer {

    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;
    import TransferStatusEnum = Meevo.Model.TransferStatusEnum;
    import ReceivalStatusEnum = Meevo.Model.ReceivalStatusEnum;

    export class InventoryTransferContext {

        //Product search criteria
        public productSearchCriteria: any = {
            productInventoryType: Meevo.Model.ProductInventoryTypeEnum.Retail,
            includeDiscontinued: true,
            receivingLocation: null,
            receivingLocationId: null,
            transferringLocation: null,
            transferringLocationId: null,
            manufacturerId: null,
        };

        protected prevTransferringLocation: any;
        protected prevReceivingLocation: any;

        protected productTypes: any;
        public showFilter: boolean = true;
        inSaveProcess: boolean = false;
        public isCo: boolean;
        public currentLocationId: number;
        public exludeLocationsFromReceivalLocation = [];
        public exludeLocationsFromTransferLocation = [];

        public inputTextPlaceholder = "";

        mode: Meevo.Model.MaintenanceFormState; // This controls the UI behavior for the Desktop
        page: Meevo.Model.MaintenanceFormVisualState;

        inventoryTransfer: Meevo.Model.InventoryTransfer;
        public addSecurityKey: string;
        public editSecurityKey: string;
        public deleteSecurityKey: string;

        public recallSecurityKey: string;
        public exportSecurityKey: string;
        public receiveSecurityKey: string;
        public transferOutSecurityKey: string;
        public returnSecurityKey: string;

        public addNoteSecurityKey: string;
        public editNoteSecurityKey: string;
        public deleteNoteSecurityKey: string;
        public readNoteSecurityKey: string;

        public canViewRecvLocOnHand: boolean = false;

        public transferAndReceivalStatus: any = [];
        public showSearch: boolean;
        public viewNotes = false;
        public showResults: boolean;
        public showReceival: boolean;
        protected baseEndpoint: string;
        //---------------------------------
        public inventoryTransferId: Guid;
        public transferringLocationId: number;
        public receivingLocationId: number;
        //---------------------------------
        public DATA_PRODUCT_TAB_MAIN: string;

        public TransferStatusEnum = TransferStatusEnum;
        public ReceivalStatusEnum = ReceivalStatusEnum;

        public $timeout: ng.ITimeoutService;
        public auditHistory: any;
        public highlightId: string;
        public filterVariant: any;
        public smartSearchFilter2 = "";
//-------------------------------------------------------------------------------------------------------
            
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public securityParts = Meevo.Components.Common.SecurityParts;
        public trackingService: Meevo.Components.Tracking.ITrackingService;
        public productVariantFilter: string;
        public product: any;
        public controller: any;
        public ProductInventoryTypeEnum = ProductInventoryTypeEnum;
 
        public $q: ng.IQService;
        public resolvedPromise = true;
      
        public topIndex: number;
        public infiteitems: any;
        public customColumns: any;
        public firstColumnName: any;     
             
        public width: number = 1200;
        
        public addingItem: any;
        public preventUsageTracking: boolean;        
        public isSideBarOpen: boolean = false;
        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;

        constructor(
            public appSettings: Meevo.Components.Common.IAppSettings,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            public modalService: Meevo.Components.Modal.ModalService,
            public inventoryTransferController: any,
            public securityChecker: Meevo.Components.Common.SecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            public identityService: Meevo.Components.Common.IIdentityService,
            public q: ng.IQService,
            public timeout: ng.ITimeoutService,
            protected $filter: angular.IFilterService,
            public reportRouterService: Meevo.Components.Common.ReportRouterService,
            public $mdSidenav: any,
            public $translate: ng.translate.ITranslateService,
            public $rootScope: angular.IRootScopeService,
            public $scope: angular.IScope,
            public busyService: Meevo.Components.Busy.IBusyService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            private lotModalBridge?: LotModalBridge) {

            this.baseEndpoint = appSettings.API_ENDPOINTS.inventoryTransfer;
            this.DATA_PRODUCT_TAB_MAIN = this.securityKeys.DATA_PRODUCT_TAB_MAIN + this.securityParts.KEY_PART_READ;
            this.mode = Meevo.Model.MaintenanceFormState.Pending;
            this.controller = inventoryTransferController;
            this.$q = q;
            this.$timeout = timeout;

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

            this.initializePage();

            this.trackingService = trackingService;
            this.buildCrudSecurityKeys(this.securityKeys.INVENTORY_TRANSFER, true);  
            this.$scope.$on('inventoryTransfer:isSideBarOpen', (event, val) => {
                this.isSideBarOpen = val;
            });

            if (this.identityService.inCentralOfficeMode()) {
                this.securityChecker.checkSecurityKey(this.securityKeys.INVENTORY_TRANSFER_RECEIVINGLOCATIONONHAND + this.securityParts.KEY_PART_READ).then(d => {
                    this.canViewRecvLocOnHand = (d == Model.SecurityAccessEnum.Grant);
                });
            }
        }

        initializePage(): void {
            this.width = $(document).width();

            this.topIndex = 0;    
            this.productVariantFilter = "";   
            
            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.ProductInventoryTypeEnum)
                .then((response: any) => {
                    if (response) {
                        this.productTypes = _.reject(response, function (it) { return it["id"] == ProductInventoryTypeEnum.Other; });
                    }
                    else {
                        this.productTypes = [];
                    }
                });
            this.showResults = false;
            this.showSearch = true;
            this.showReceival = false;
            //add location to exlude from typeAhead
            //storeNumber
            this.exludeLocationsFromTransferLocation.push({ id: this.identityService.effectiveLocationId });
            this.exludeLocationsFromReceivalLocation.push({ id: this.identityService.effectiveLocationId });

            //translate placeholder
            this.inputTextPlaceholder = this.$translate.instant("LABEL_SEARCH_PLACEHOLDER");
            //check if CO
            this.isCo = this.identityService.inCentralOfficeMode();
            this.currentLocationId = this.identityService.effectiveLocationId;
            //Column header
            this.firstColumnName = { header: "", fieldName: 'empyHeader', sortDirection: Model.SortDirection.Descending, width: 0, className: 'transfer-header transfer-number-hide' };
            this.customColumns = [
                { header: this.$translate.instant("LABEL_INVENTORY_TRANSFER_NUMBER"), fieldName: 'inventoyTransferNumber', sortDirection: Model.SortDirection.Descending, width: 10, className: 'transfer-header transfer-number' },
                { header: this.$translate.instant("LABEL_INVENTORY_TRANSFER_NAME"), fieldName: 'inventoyTransferName', sortDirection: null, width: 20, className: 'transfer-header transfer-name' },
                { header: this.$translate.instant("LABEL_PRODUCTS"), fieldName: 'product', sortDirection: null, width: 10, className: 'transfer-header transfer-product' },
                { header: this.$translate.instant("LABEL_TRANSFER_FROM"), fieldName: 'transferFrom', sortDirection: null, width: 15, className: 'transfer-header transfer-from-location' },
            ];
            if (this.isCo) {
                this.customColumns.push({ header: this.$translate.instant("LABEL_TRANSFER_FROM_STATUS"), fieldName: 'transferFromStatus', sortDirection: null, width: 10, className: 'transfer-header transfer-from-status' });
            }
            this.customColumns.push({ header: this.$translate.instant("LABEL_TRANSFER_DATE"), fieldName: 'transferDate', sortDirection: null, width: 10, className: 'transfer-header transfer-date' });
            this.customColumns.push({ header: this.$translate.instant('LABEL_TRANSFER_TO'), fieldName: 'transferTo', sortDirection: null, width: 15, className: 'transfer-header transfer-to-location' });
            if (this.isCo) {
                this.customColumns.push({ header: this.$translate.instant('LABEL_TRANSFER_TO_STATUS'), fieldName: 'transferToStatus', sortDirection: null, width: 10, className: 'transfer-header transfer-to-status' });
            }
            else {
                this.customColumns.push({ header: this.$translate.instant('LABEL_TRANSFER_STATUS'), fieldName: 'transferStatus', sortDirection: null, width: 10 });
            }
            //Filter dropdown
            this.transferAndReceivalStatus = [
                { id: 1, displayName: this.$translate.instant('LABEL_ACTIVE_TRANSFER') }, 
                { id: 2, displayName: this.$translate.instant('LABEL_ALL_TRANSFER') }, 
                { id: 3, displayName: this.$translate.instant('LABEL_SAVED_TRANSFER') }, 
                { id: 4, displayName: this.$translate.instant('LABEL_TRANSFERRED_TRANSFER') },
                { id: 5, displayName: this.$translate.instant('LABEL_NOT_RECEIVED_TRANSFER') },
                { id: 6, displayName: this.$translate.instant('LABEL_RECEIVED_TRANSFER') },
                { id: 7, displayName: this.$translate.instant('LABEL_RETURNED_TRANSFER') },
                { id: 8, displayName: this.$translate.instant('LABEL_RETURN_NOT_RECEIVED_TRANSFER') },
                { id: 9, displayName: this.$translate.instant('LABEL_RETURN_RECEIVED_TRANSFER') },
                { id: 10, displayName: this.$translate.instant('LABEL_DELETED_TRANSFER') }
            ]            
        }

        createNew(): void {
            this.mode = MaintenanceFormState.Adding;
            this.showResults = true;
            this.showSearch = false;
            this.showTheFilter();            
            this.getTemplate()
            this.$timeout(() => {              
                this.showSidebar();
            }, 150);
        }
        getTemplate(): ng.IPromise<any> {
            return this.dataService.customMethodData(`api/${this.baseEndpoint}/Template`, "GET", null).then((d) => {
                this.inventoryTransfer = d.data;
                let filter: any = this.$filter;
                let meevoDate = filter('meevoDateFilter');
                let meeevoTime = filter('meevoTimeWithSecondsFilter');
                this.inventoryTransfer.displayName = `Inventory Transfer created on ${meevoDate(new Date())} at ${meeevoTime(new Date())} `; 

                  //make  from/to location fields blank
                this.productSearchCriteria.receivingLocation = null;
                this.productSearchCriteria.receivingLocationId = null;
                this.productSearchCriteria.transferringLocation = null;
                this.productSearchCriteria.transferringLocationId = null;
                this.inventoryTransfer.lineItems = [];
            });
        } 
        
        //Update Searcch criteria
        updateProductSearchCriteria() {
            if (this.productSearchCriteria != undefined) {
                this.productSearchCriteria.transferringLocationId = !this.isCo ? this.identityService.effectiveLocationId : this.productSearchCriteria.transferringLocation != undefined ? this.productSearchCriteria.transferringLocation.id : null;
                this.productSearchCriteria.receivingLocationId = this.productSearchCriteria.receivingLocation != undefined ? this.productSearchCriteria.receivingLocation.id : null;
                this.productSearchCriteria.manufacturerId = this.productSearchCriteria.manufacturer != undefined ? this.productSearchCriteria.manufacturer.id : null;

                this.$timeout(() => {
                    this.hideSidebar();
                }, 150);
            }
        }
        //side bar
        showSidebar = () => {
            var sideBar = this.$mdSidenav('inventoryTransferSidenav');
            if (sideBar) {
                sideBar.open();
                setTimeout(() => {
                    this.isSideBarOpen = true;
                }, 0);
            }
        }
        hideSidebar = () => {
            this.isSideBarOpen = false;
            var sideBar = this.$mdSidenav('inventoryTransferSidenav');
            if (sideBar) {
                sideBar.close();
            }
        }

        hideOrShowFilter = () => {
            this.showFilter = !this.showFilter;
        }

        showTheFilter(): void {
            this.showFilter = true;
        }

        calcFormWidth(): any {
            return { 
                "width": `${angular.element(document).find('body')[0].clientWidth - 36}px` 
            };
        }

        //location typeahead changed
        transferringLocationChanged(loc) {
            if (this.inventoryTransfer && this.inventoryTransfer.lineItems && this.inventoryTransfer.lineItems.length > 0) {
                return this.modalService.confirm("MESSAGE_TRANSFER_TRANSFERRING_LOCATION_CHANGED")
                    .then(() => { this.transferringLocationChangedWorker(loc); })
                    .catch (() => {
                        this.productSearchCriteria.transferringLocationId = this.prevTransferringLocation.id;
                        this.productSearchCriteria.transferringLocation = angular.copy(this.prevTransferringLocation);
                    });
            }
            else {
                return this.$q.resolve(true)
                    .then(() => { this.transferringLocationChangedWorker(loc); });
            }
        }
        transferringLocationChangedWorker(loc) {
            if (loc) {
                this.exludeLocationsFromReceivalLocation.push({ id: loc.id });
                this.productSearchCriteria.transferringLocationId = !this.isCo ? this.identityService.effectiveLocationId : loc.id;
            }
            else {
                this.exludeLocationsFromReceivalLocation.length = 0;
                this.exludeLocationsFromReceivalLocation.push({ id: this.identityService.effectiveLocationId });
                this.productSearchCriteria.transferringLocationId = !this.isCo ? this.identityService.effectiveLocationId : null;
            }
            this.prevTransferringLocation = angular.copy(loc);
            this.inventoryTransfer.lineItems.length = 0;
        }
        receivingLocationChanged(loc) {
            if (this.inventoryTransfer && this.inventoryTransfer.lineItems && this.inventoryTransfer.lineItems.length > 0) {
                return this.modalService.confirm("MESSAGE_TRANSFER_RECEIVING_LOCATION_CHANGED")
                    .then(() => { this.receivingLocationChangedWorker(loc); })
                    .catch(() => {
                        this.productSearchCriteria.receivingLocationId = this.prevReceivingLocation.id;
                        this.productSearchCriteria.receivingLocation = angular.copy(this.prevReceivingLocation);
                    });
            }
            else {
                return this.$q.resolve(true)
                    .then(() => { this.receivingLocationChangedWorker(loc); });
            }
        }
        receivingLocationChangedWorker(loc) {
            if (loc) {
                this.exludeLocationsFromTransferLocation.push({ id: loc.id });
                this.productSearchCriteria.receivingLocationId = loc.id;
            }
            else {
                this.exludeLocationsFromTransferLocation.length = 0;
                this.exludeLocationsFromTransferLocation.push({ id: this.identityService.effectiveLocationId });
                this.productSearchCriteria.receivingLocationId = null;
            }
            this.prevReceivingLocation = angular.copy(loc);
            this.inventoryTransfer.lineItems.length = 0;
        }

        //mode control
        isAdding(): boolean {
            return this.mode == MaintenanceFormState.Adding;
        }

        isEditing(): boolean {
            return this.mode == MaintenanceFormState.Editing;
        }

        isReadonly(): boolean {
            return this.mode == MaintenanceFormState.Readonly;
        }
        isPending(): boolean {
            if (this.mode == MaintenanceFormState.Pending)
                return true;
            else
                return false;
        }

        //CRUD
        select(id: Guid, isCoReceival?: boolean): ng.IPromise<any> {
            if (!id) return;

            return this.dataService.customMethodData(`api/${this.baseEndpoint}/${id}`, "GET", null).then((d) => {
                this.inventoryTransfer = d.data;
                this.inventoryTransfer.isFinalUnitPriceCalculated = this.inventoryTransfer.lineItems &&
                                                                    this.inventoryTransfer.lineItems.length > 0 &&
                                                                    (_.findIndex(this.inventoryTransfer.lineItems, (v) => {
                                                                        return v.finalUnitPrice && v.finalUnitPrice > 0
                                                                    })) >= 0;

                if ((this.inventoryTransfer &&
                    this.inventoryTransfer.transferStatus == this.TransferStatusEnum.Transferred &&
                    (this.inventoryTransfer.receivalStatus == this.ReceivalStatusEnum.NotReceived ||
                     this.inventoryTransfer.receivalStatus == this.ReceivalStatusEnum.Received) &&
                    this.inventoryTransfer.receivingLocationId == this.currentLocationId &&
                    !this.isCo) || isCoReceival) {
                    this.showReceival = true;
                }
                else {
                    this.productSearchCriteria.transferringLocation = {
                        id: this.inventoryTransfer.transferringLocationId,
                        storeName: this.inventoryTransfer.transferringLocation
                    }
                    this.productSearchCriteria.receivingLocation = {
                        id: this.inventoryTransfer.receivingLocationId,
                        storeName: this.inventoryTransfer.receivingLocation
                    }
                    this.showReceival = false;
                }
                this.showSearch = false;
                this.mode = MaintenanceFormState.Readonly;
                this.showResults = true;
                this.$timeout(() => {
                    this.hideSidebar();
                    return this.inventoryTransfer;
                }, 150);
            });
        }

        save(): ng.IPromise<any> {
            var invalidQty = false;
            var urlSuffix = "";
            if (this.inSaveProcess)
                return;
            if (!this.inventoryTransfer && !this.inventoryTransfer.lineItems && this.inventoryTransfer.lineItems.length == 0)
                return;

            this.inventoryTransfer.transferringLocationId = this.inventoryTransfer.transferringLocationId ? this.inventoryTransfer.transferringLocationId :
                this.isCo ? this.productSearchCriteria["transferringLocationId"] : this.identityService.effectiveLocationId;

            this.inventoryTransfer.receivingLocationId = this.inventoryTransfer.receivingLocationId ?
                                                         this.inventoryTransfer.receivingLocationId :
                                                         this.productSearchCriteria["receivingLocationId"];

            // Lot allocation rules (missing / duplicate lot ids / fractional /
            // sum mismatch) live solely on the server validator
            // (InventoryTransferValidator). Each rule has a specific i18n key
            // that's surfaced via the normal exception path — host-side
            // pre-checks were removed to keep a single source of truth and
            // avoid drift between client- and server-side messages.

            // For lot-tracked rows, transferQuantity is authoritative as the sum of
            // allocations. Recompute here so any modal-apply / model drift can't
            // skew the line total on save (the sproc validates sum-of-lots ==
            // TransferQuantity per lot-tracked line; mismatch throws).
            this.inventoryTransfer.lineItems.forEach((li) => {
                if (li.trackLots && li.lotAllocations && li.lotAllocations.length > 0) {
                    li.transferQuantity = li.lotAllocations.reduce(
                        (sum: number, a) => sum + (a.quantity || 0), 0);
                    li.lineTotal = this.calculateLineTotal(li);
                }
            });
            var validLineItems = _.filter(this.inventoryTransfer.lineItems, function (item) { return item.transferQuantity > 0; });
            if (!validLineItems || validLineItems.length == 0) {
                return this.modalService.alert(this.$translate.instant("MESSAGE_LINE_ITEM_EMPTY"), null);
            }
            this.inventoryTransfer.lineItems = validLineItems;
            this.inventoryTransfer.lineItems.forEach((li, index) => {
                li.estimatedUnitPrice = li.unitPrice;
                li.lineNumber = index + 1;
                // Lot-tracked rows have per-lot on-hand validated in the modal /
                // by the sproc at status flip — skip the aggregate onHand check
                // here so the variant-level "onHand < transferQuantity" path
                // doesn't fire a misleading warning when the user has correctly
                // allocated across multiple lots.
                if (!li.trackLots && li.onHand < li.transferQuantity && !invalidQty) {
                    invalidQty = true;
                }
            })

            let method = "POST"
            if (this.inventoryTransfer.id != undefined && this.inventoryTransfer.id != Guid.empty) {
                method = "PUT";
            }
            //update header
            if (this.inventoryTransfer.transferStatusBW != TransferStatusEnum.Saved && this.inventoryTransfer.id != undefined && this.inventoryTransfer.id != Guid.empty) {               
                urlSuffix ="Header"
            }
            if (invalidQty && (method == "POST" || (method == "PUT" && this.inventoryTransfer.transferStatusBW == TransferStatusEnum.Saved))) {
                return this.modalService.message(this.$translate.instant("MESSAGE_QTY_HIGHER_ONHAND"), null);
            }
            this.inSaveProcess = true;
            this.busyService.start();
            return this.dataService.customMethodData(`api/${this.baseEndpoint}${urlSuffix}`, method, this.inventoryTransfer).then((d) => {
                this.inventoryTransfer = d.data;                
                if (this.mode == Meevo.Model.MaintenanceFormState.Editing)//change audit model
                    this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransfer, Model.VerbEnum.SaveButtonClicked, null, null);
                this.mode = MaintenanceFormState.Readonly;
            }).catch((error) => {
                let a = error;
            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
            });
        }

        edit() {
            this.mode = MaintenanceFormState.Editing;
        }

        resetCriteria() {
            //make  from/to location fields blank
            this.productSearchCriteria.receivingLocation = null;
            this.productSearchCriteria.receivingLocationId = null;
            this.productSearchCriteria.transferringLocation = null;
            this.productSearchCriteria.transferringLocationId = null;
            this.productSearchCriteria.productInventoryType = Meevo.Model.ProductInventoryTypeEnum.Retail;
            this.productSearchCriteria.includeDiscontinued = true;
            this.productSearchCriteria.manufacturerId = null;
            this.inventoryTransfer = null;
            this.exludeLocationsFromTransferLocation.length = 0;
            this.exludeLocationsFromTransferLocation.push({ id: this.identityService.effectiveLocationId });
            this.exludeLocationsFromReceivalLocation.length = 0;
            this.exludeLocationsFromReceivalLocation.push({ id: this.identityService.effectiveLocationId });
        }

        cancel(): void {
            if (this.mode == MaintenanceFormState.Editing)
                this.mode = MaintenanceFormState.Readonly;
            else {
                this.resetCriteria();
                this.showSearch = true;
                this.viewNotes = false;
                this.showResults = false;
                this.mode = MaintenanceFormState.Readonly;
            }
        }
        delete(id: Guid): ng.IPromise<any> {
            if (!this.inventoryTransfer)
                return; 
            let deleteConfirmMessage = this.$translate.instant("MESSAGE_TRANSFER_DELETE_SAVED");
            var request = {
                id: this.inventoryTransfer.id,
                entityVersion: this.inventoryTransfer.entityVersion
            };
            return this.modalService.warning(deleteConfirmMessage, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((data) => {
                    if (this.inSaveProcess)
                        return;
                    this.inSaveProcess = true;
                    this.busyService.start();
                    return this.dataService.customMethodData(`api/${this.baseEndpoint}/${id}`, "Patch", request).then((d) => {
                        this.inventoryTransfer = d.data;
                        //audit log
                        this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransfer, Model.VerbEnum.DeleteButtonClicked, null, null);
                        this.mode = MaintenanceFormState.Readonly;
                    }).catch((error) => {
                        return false;;
                    }).finally(() => {
                        this.busyService.stop();
                        this.inSaveProcess = false;
                        return true;
                    });
                });
        }

        receiveTransfer(message:string) {
            let receiveConfirmMessage = this.$translate.instant(message);
            return this.modalService.alert(receiveConfirmMessage, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((data) => {
                    if (this.inSaveProcess)
                        return;
                    if (!this.inventoryTransfer)
                        return;
                    var request = {
                        id: this.inventoryTransfer.id,
                        entityVersion: this.inventoryTransfer.entityVersion
                    };
                    this.inSaveProcess = true;
                    this.busyService.start();
                    return this.dataService.customMethodData(`api/${this.baseEndpoint}/${request.id}/Receive`, "PUT", request).then((d) => {
                        this.inventoryTransfer = d.data;
                        this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransfer, Model.VerbEnum.ReceiveButtonClicked, null, null);
                        this.mode = MaintenanceFormState.Readonly;

                    }).catch((error) => {

                    }).finally(() => {
                        this.busyService.stop();
                        this.inSaveProcess = false;
                    });
                });
        }
        returnTransfer() {
            let returnConfirmMessage = this.$translate.instant("MESSAGE_TRANSFER_RETURN_CONFIRMATION");
            return this.modalService.alert(returnConfirmMessage, 0, true, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((data) => {
                    if (this.inSaveProcess)
                        return;
                    if (!this.inventoryTransfer)
                        return;
                    var request = {
                        id: this.inventoryTransfer.id,
                        entityVersion: this.inventoryTransfer.entityVersion
                    };
                    this.inSaveProcess = true;
                    this.busyService.start();
                    return this.dataService.customMethodData(`api/${this.baseEndpoint}/${request.id}/Return`, "PUT", request).then((d) => {
                        this.inventoryTransfer = d.data;
                        this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransfer, Model.VerbEnum.ReturnButtonClicked, null, null);
                        this.mode = MaintenanceFormState.Readonly;

                    }).catch((error) => {

                    }).finally(() => {
                        this.busyService.stop();
                        this.inSaveProcess = false;
                    });
                });
        }
        recallTransfer() {
            let recallConfirmMessage = this.$translate.instant("MESSAGE_TRANSFER_RECALL");
            return this.modalService.alert(recallConfirmMessage, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((data) => {
            if (this.inSaveProcess)
                return;
            if (!this.inventoryTransfer)
                return;

            var request = {
                id: this.inventoryTransfer.id,
                entityVersion: this.inventoryTransfer.entityVersion
            };
            this.inSaveProcess = true;
            this.busyService.start();
                    return this.dataService.customMethodData(`api/${this.baseEndpoint}/${request.id}/Recall`, "PUT", request).then((d) => {
                this.inventoryTransfer = d.data;
                this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransfer, Model.VerbEnum.RecallButtonClicked, null, null);
                this.mode = MaintenanceFormState.Readonly;

            }).catch((error) => {

            }).finally(() => {
                this.busyService.stop();
                this.inSaveProcess = false;
            });
        });
        }
        transferOut() {
            let transferConfirmMessage = this.$translate.instant("MESSAGE_TRANSFER_OUT");
            return this.modalService.alert(transferConfirmMessage, 0, true, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((data) => {
                    if (this.inSaveProcess)
                        return;
                    if (!this.inventoryTransfer)
                        return;
                    /*var request = {
                        id: this.inventoryTransfer.id,
                        entityVersion: this.inventoryTransfer.entityVersion
                    };*/
                    this.inSaveProcess = true;
                    this.busyService.start();
                    return this.dataService.customMethodData(`api/${this.baseEndpoint}/${this.inventoryTransfer.id}/Transfer`, "PUT", this.inventoryTransfer).then((d) => {
                        this.inventoryTransfer = d.data;
                        this.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransfer, Model.VerbEnum.TransferButtonClicked, null, null);
                        this.mode = MaintenanceFormState.Readonly;

                    }).catch((error) => {

                    }).finally(() => {
                        this.busyService.stop();
                        this.inSaveProcess = false;
                    });
                });
        }
        //export transfer header
        exportTransferSearch(intelligentSearchFilter, criteria) {
            
            var filterValue = Model.Guard.isSomething(`${intelligentSearchFilter}`) ? intelligentSearchFilter : null;
            criteria.filter = filterValue;
            var request = {
                criteria: criteria,
                itemsPerPage: 25,
                pageNumber: 0
            };
            this.busyService.start();
            return this.dataService.customMethodData(`api/${this.baseEndpoint}/Export`, "POST", request).then((data) => {
                if (data.data != null) {
                    this.usageTrackingLog(Meevo.Model.NounEnum.TransferExportPage, Model.VerbEnum.ExportButtonClicked, null, null);
                    this.$timeout(() => {
                        this.download(data.data, "InventoryTransferSearch.csv")
                    }, 1);
                }
                else {
                    this.modalService.alert(this.$translate.instant("MESSAGE_DOESNT_MEET_SEARCH_CRITERIA"));
                }
            }).finally(() => {                
                this.busyService.stop();
            });
        }

        //export line items
        export(id?: Guid) {
            if (id) {
                this.busyService.start();
                this.dataService.customMethodData(`api/${this.baseEndpoint}/${id}/Export`, "GET", null).then((data) => {
                    if (data.data != null) {
                        this.$timeout(() => {
                            this.usageTrackingLog(Meevo.Model.NounEnum.TransferExportPage, Model.VerbEnum.ExportButtonClicked, null, id);
                            this.download(data.data, "InventoryTransferDetail.csv")
                        }, 1);
                    }
                    else {
                        this.modalService.alert(this.$translate.instant("MESSAGE_DOESNT_MEET_SEARCH_CRITERIA"));
                    }
                }).finally(() => {
                    this.busyService.stop();
                });
            }
            else {

            }
        }
        //download csv
        download(csvFile:string, filename:string) {
            var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link["download"] !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        }
        routeToReport(transfer) {
            //TODO: will be uncommented once the proc usp_Report_DP005_Product_Location_List_Get includes transfers
            return this.reportRouterService.routeToReportWithCustomData(this.meevoSecurityKeys.REPORTS_PRODUCT_DP005, transfer);
        }

        //back to search
        collapse() {
            if (this.viewNotes) {
                this.backFromNote();
            }
            else {
                this.resetCriteria();
                this.showSearch = true;
                this.viewNotes = false;
                this.showResults = false;
                this.showReceival = false;
                this.mode = MaintenanceFormState.Readonly;
                this.$timeout(() => {
                    $("#inventoryTransferSearch").click();
                }, 1);
            }
        }
        note(id: Guid, transferringLocationId: number,receivingLocationId: number, isSearch: boolean) {
            //note source page
            if (isSearch)
                this.page = Meevo.Model.MaintenanceFormVisualState.Search;
            else
                this.page = Meevo.Model.MaintenanceFormVisualState.Detail;

            this.mode = MaintenanceFormState.Readonly;
            //--------------Note Template---------------------------------
            this.inventoryTransferId = id;
            this.transferringLocationId = transferringLocationId;
            this.receivingLocationId = receivingLocationId;
            ///------------------------------------------------
            this.viewNotes = true;
            this.showResults = false;
            this.showSearch = false;
            this.getNotes(id);
        }

        /* Get list of notes 
        * @param inventoryTransferId
        */
        getNotes(id: Guid) {
            if (id == undefined || id == Guid.empty)
                return;
            let request = {
                pageNumber: 0,
                itemsPerPage: 25,
                criteria: {
                    inventoryTransferId: id,
                    objectState: Meevo.Model.ObjectStateEnum.Active
                },
                sortBy: 'DateCreated',
                sortDirection: Model.SortDirection.Descending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            }
            var url = `${this.baseEndpoint}/${id}/Note`;
            this.infiteitems = new Meevo.Components.BaseClasses.PagedResults(this.dataService, url);
            this.infiteitems.clearSearch();
            this.infiteitems.initSearch(request);
        }

        deleteNote(note): void {
            var scope = this;
            if (note != null && !note.isDistributorNote) {
                this.modalService.warning('MESSAGE_TRANSFER_NOTE_DELETE', Meevo.Components.Modal.ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((res: boolean) => {
                        if (res) {
                            note.objectState = Meevo.Model.ObjectStateEnum.Deleted;
                            scope.dataService.customMethodData(`api/${this.baseEndpoint}/${note.id}/Note`, "Patch", note).then((response) => {
                                //change the object state to deleted
                                scope.getNotes(scope.inventoryTransferId);
                                //audit log
                                if (!scope.preventUsageTracking) {
                                    scope.usageTrackingLog(Meevo.Model.NounEnum.InventoryTransferNote, Model.VerbEnum.DeleteButtonClicked, null, scope.inventoryTransferId);
                                }
                            });
                        }
                    });
            }
        }

        backFromReceival() {
            if (this.isCo) {
                this.showSearch = false;
                this.showResults = true;
            }
            else {
                this.showSearch = true;
                this.showResults = false;
                this.$timeout(() => {
                    $("#inventoryTransferSearch").click();
                }, 1);
            }
           
            this.viewNotes = false;
            this.showReceival = false;
            this.mode = MaintenanceFormState.Readonly;
        }

        backFromNote() {
            this.viewNotes = false;
            if (this.page === Meevo.Model.MaintenanceFormVisualState.Detail) {  //show the page list item
                this.showResults = true;
                this.showSearch = false;
            }
            else if (this.page === Meevo.Model.MaintenanceFormVisualState.Search) {//show search page
                this.showResults = false;
                this.showSearch = true;
                this.$timeout(() => {
                    $("#inventoryTransferSearch").click();
                }, 1);
            }
        }
        
        transferQuantityItemChanged(item: Meevo.Model.InventoryTransferLineItem): void {
            if (!item || !item.id) return;
            if (item.transferQuantity.toString() == "" || item.transferQuantity == undefined)
                item.transferQuantity = 0;
            item.lineTotal = this.calculateLineTotal(item);            
        }

        transferQuantityItemcalculate() {
            var scope = this;

            return scope.modalService.confirm("MESSAGE_AUTOMATIC_TRANSFER_CONFIRMATION", Meevo.Components.Modal.ModalTranslationModes.Translate).then((data) => {
                if (this.inventoryTransfer && this.inventoryTransfer.lineItems && this.inventoryTransfer.lineItems.length > 0) {
                    var isCriteriaMatch: boolean = false;
                    for (var i = 0; i < this.inventoryTransfer.lineItems.length; i++) {
                        var thisItem = this.inventoryTransfer.lineItems[i];

                        if (thisItem.receivingLocationOnHand < thisItem.receivingLocationModelQuantity && thisItem.receivingLocationOnHand <= thisItem.receivingLocationOrderPoint) {
                            var suggested = thisItem.receivingLocationModelQuantity - thisItem.receivingLocationOnHand;
                            if (suggested > thisItem.onHand) {
                                suggested = thisItem.onHand;
                            }

                            if (thisItem.trackLots) {
                                // FA8: for lot-tracked rows Autofill surfaces a suggestion
                                // inside the lot allocation modal — it does NOT mutate
                                // transferQuantity or lotAllocations. The user must still
                                // pick lots manually. The hint clears once an allocation
                                // is applied (see openLotAllocationModal onSaved handler).
                                thisItem.autofillSuggestedQty = suggested;
                            }
                            else {
                                thisItem.transferQuantity = suggested;
                                thisItem.lineTotal = this.calculateLineTotal(thisItem);
                            }
                            isCriteriaMatch = true;
                        }

                    }
                    if (!isCriteriaMatch) {
                        return scope.modalService.alert("No products have met the criteria to be transfer at this moment. (No change has been made to this transfer order)", null);
                    }
                }
            });
        }

        calculateLineTotal(item: Meevo.Model.InventoryTransferLineItem): number {
            if (!item || !item.id) return;
            return item ? this.calculateLineTotalWithValues(item.transferQuantity, item.unitPrice) : 0;
        }
        calculateLineTotalWithValues(quantity: number, unitPrice: number): number {
            return this.roundingService.multiplyNormalizedNumbers(unitPrice, quantity);            
        }
        addVariantFromTypeAhead = (item) => {
            if (item != null) {
                // FA8: lot-tracked variants enter the grid with transferQuantity=0 and an
                // empty lotAllocations list. The user picks lots + quantities inside the
                // lot allocation modal; transferQuantity is recomputed as sum(allocations)
                // on Apply and again at Save (see save()). Non-lot variants keep the
                // legacy "auto-set to 1 on add" behavior.
                if (item.trackLots) {
                    item.transferQuantity = 0;
                    item.lotAllocations = [];
                    item.lineTotal = this.calculateLineTotal(item);
                }
                else if (item.transferQuantity == 0) {
                    item.transferQuantity = 1;
                    item.lineTotal = this.calculateLineTotal(item);
                }
                var lineItemFound = false;
                if (this.inventoryTransfer && this.inventoryTransfer.lineItems && this.inventoryTransfer.lineItems.length > 0) {
                    var ndx = _.findIndex(this.inventoryTransfer.lineItems, (v) => { return v.id == item.id && v.productInventoryType == item.productInventoryType });
                    if (ndx >= 0) {
                        // Re-adding an existing lot-tracked row is a no-op (the user must
                        // re-open the modal to change allocations). Non-lot rows keep
                        // the legacy "bump to 1 if currently 0" behavior so a duplicate
                        // typeahead add nudges the user toward a non-zero quantity.
                        if (!this.inventoryTransfer.lineItems[ndx].trackLots
                            && this.inventoryTransfer.lineItems[ndx].transferQuantity == 0) {
                            this.inventoryTransfer.lineItems[ndx].transferQuantity = 1;
                        }
                        lineItemFound = true;
                    }
                }
                if (!lineItemFound)
                    this.inventoryTransfer.lineItems.push(item);
                this.filterVariant = null;
            }

            this.$timeout(() => {
                this.ScrollToProduct(item.id, item.productInventoryType);
            }, 500);
        }

        ScrollToProduct = (id, productInventoryType) => {
            //var variantElemId = "productId_" + id + "_" + productInventoryType;
            //var variantElem = document.getElementById(variantElemId);
            //if (variantElem) {
            //    variantElem.scrollIntoView();
            //}
            //else {

                var ndx = _.findIndex(this.inventoryTransfer.lineItems, (item) => { return item.id == id && item.productInventoryType == productInventoryType });
                //var heightOfItem = document.getElementsByClassName("inv-row")[0] ? document.getElementsByClassName("inv-row")[0].clientHeight + 4 : 45; //4px of padding

                if (this.showResults) {
                    var thisParent = document.getElementById("inventory_transfer_item_list");

                    let elemList = thisParent.getElementsByClassName("inventory-repeat");
                    let heightOfItem: number = 45;
                    if (elemList && elemList.length && elemList.length > 0) {
                        heightOfItem = elemList[0].clientHeight + 4; //4px of padding
                    }
                    if (heightOfItem > 100) {
                        heightOfItem += 1; // adjustment to padding
                    }

                    let newScrollTop: number = ndx <= 0 ? 0 : (ndx * heightOfItem) - 10;

                    // scroll to top of first item matched
                    var el = document.getElementById("inv-transfer-maint-edit-form"); // there can only be one
                    if (el) {
                        newScrollTop = newScrollTop > (el.scrollHeight - el.clientHeight) ? (el.scrollHeight - el.clientHeight) : newScrollTop;
                        el.scroll(0, newScrollTop);
                    }
                }

            //}
            this.highlightId = this.getConcatenatedString(id, productInventoryType);

            this.$timeout(() => {
                // have the highlightId reset itself after 2 seconds (length of animation)
                this.highlightId = null;
               // this.hideSidebar();
            }, 2000);

            this.hideList2();
            this.smartSearchFilter2 = '';
        }
        filterProductsInDropdown = (val: string) => {
            if (!this.inventoryTransfer || !this.inventoryTransfer.lineItems || this.inventoryTransfer.lineItems.length == 0 || !val) return null;
            var data = this.inventoryTransfer.lineItems;
            var reList = _.map(val.split(" "), (w: string) => new RegExp("\\b" + w, "i"));
            return data.filter(x => _.all(reList, (re) => re.test(x.sku)
                || re.test(x.displayName)
                || re.test(x.productDisplayName)
                || re.test(x.barCode)));
        }

        showList2 = () => {
            if (this.smartSearchFilter2 != '') {
                var list = $("#list4");
                list.show();
            }
            else {
                this.hideList2();
            }
        }

        hideList2 = () => {
            var list = $("#list2");
            list.hide();
            var list2 = $("#list4");
            list2.hide();
            this.smartSearchFilter2 = '';
        }
        
        /*  SECURITY KEYS */
        protected buildCrudSecurityKeys(baseKey, hasCreateKey = false, hasCopyKey = false, hasChangeAccessKey = false, hasChangeOwnerKey = false) {
            this.addSecurityKey = baseKey + ((hasCreateKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_CREATE : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;

            this.exportSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_ACTION + ":EXPORT";
            this.recallSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_ACTION + ":RECALL";
            this.receiveSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_ACTION + ":RECEIVE";
            this.transferOutSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_ACTION + ":TRANSFEROUT";
            this.returnSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_ACTION + ":RETURN";
            
            this.addNoteSecurityKey = this.securityKeys.INVENTORY_TRANSFERNOTE + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteNoteSecurityKey = this.securityKeys.INVENTORY_TRANSFERNOTE + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.editNoteSecurityKey = this.securityKeys.INVENTORY_TRANSFERNOTE + Meevo.Components.Common.SecurityParts.KEY_PART_EDIT;
            this.readNoteSecurityKey = this.securityKeys.INVENTORY_TRANSFERNOTE + Meevo.Components.Common.SecurityParts.KEY_PART_READ;
        }

        /*   TRACKING */
        usageTrackingLog(nounEnum, verbEnum, payload, mainEntityId): void {
            if (nounEnum !== null) {
                var trackingItem = new Meevo.Model.TrackingItem(nounEnum, verbEnum, payload, mainEntityId);
                this.trackingService.saveTrackingInfo(trackingItem);
            }
        }

        removeLineItems(item) {
            if (this.inventoryTransfer && (this.inventoryTransfer.lineItems && this.inventoryTransfer.lineItems.length > 0)) {
                let index = _.findIndex(this.inventoryTransfer.lineItems, (i) => { return i.id == item.id && i.productInventoryType == item.productInventoryType });
                if (index >= 0) {
                    this.inventoryTransfer.lineItems.splice(index, 1);
                }
            }
        }
        /**
        * Before search callbalck
        * @param criteria
        * @param rootCriteria
        */
        preSearchCallback(criteria, rootCriteria) {
            criteria.manufacturerId = (criteria.manufacturer && criteria.manufacturer.id) ? criteria.manufacturer.id : null;
            criteria.transferringLocationId = (criteria.transferringLocation && criteria.transferringLocation.id) ? criteria.transferringLocation.id : null;
            criteria.receivingLocationId = (criteria.receivingLocation && criteria.receivingLocation.id) ? criteria.receivingLocation.id : null;
            if (!criteria.status)
                criteria.status = 1;
        }

        refreshProductSearchCriteria() {
            if (this.productSearchCriteria != undefined) {
                this.productSearchCriteria.transferringLocationId = !this.isCo ? this.identityService.effectiveLocationId : this.productSearchCriteria.transferringLocation != undefined ? this.productSearchCriteria.transferringLocation.id : null;
                this.productSearchCriteria.receivingLocationId = this.productSearchCriteria.receivingLocation != undefined ? this.productSearchCriteria.receivingLocation.id : null;
                this.productSearchCriteria.manufacturerId = this.productSearchCriteria.manufacturer != undefined ? this.productSearchCriteria.manufacturer.id : null;
            }
        }
        //calculate summary
        getTotal(type: string): number {
            if (!this.inventoryTransfer || !this.inventoryTransfer.lineItems) return 0;
            switch (type) {
                case 'overall':
                    return this.roundingService.addNormalizedNumbersSpread(parseFloat(this.inventoryTransfer.tax.toString()), parseFloat(this.inventoryTransfer.shippingHandling.toString()), this.getTotal('subtotal'));
                case 'subtotal':
                    return this.inventoryTransfer.lineItems.reduce((a, b) => this.roundingService.addNormalizedNumbers(a, parseFloat(b.lineTotal.toString())), 0);
                case 'transferQty':
                    return this.inventoryTransfer.lineItems.reduce((a, b) => a + b.transferQuantity, 0);
            }
        }
        /**
         * Open selected Product in Product Screen
         * @param {number} productId
         */
        openProductDefinition(productId: string): void {
            if (!productId) return;

            // Build params for loading Product Definition
            let stateParams = {
                id: productId,
                actionState: Meevo.Model.MaintenanceFormState.Readonly,
                targetState: Meevo.Model.MaintenanceFormVisualState.Detail
            };

            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.product,
                stateParams: stateParams
            });
        }
        
        showInformation(prod: any) {
            let modalOptions : Meevo.Plugins.Product.ProductInfoModalOptions = {
                parentType: Meevo.Plugins.Product.ProductInfoModalParent.InventoryTransfer,
                productId: prod.productId,
                variantId: prod.id,
                productInventoryTypeEnum: prod.productInventoryType
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/product/modals/productInformation.template.html",
                controller: "meevo.plugins.product.ProductInformationController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    options: modalOptions
                }
            };
            return this.modalService.showCustom(options);            
        }

        returnAttributeConcatinatedName(attributes: any): string {
            if (attributes != null && attributes.length != null && attributes.length > 0) {
                var concatdisplayName = "";
                for (var i = 0; i < attributes.length; i++) {
                    for (var j = 0; j < attributes[i].displayName.length; j++) {
                        if (j + 1 < attributes[i].displayName.length || i + 1 < attributes.length)
                            concatdisplayName += attributes[i].displayName[j] + " / ";
                        else {
                            concatdisplayName += attributes[i].displayName[j];
                        }
                    }
                }
                return " - " + concatdisplayName;
            }
            return "";
        }

        closeCustomModal(): void {
            this.modalService.hide();
        }
        isSecurityDenyOrGrant(key): boolean {
            return this.securityChecker.hasSecurityDenyOrGrant(key);
        }      

        doHighlight = (item) => {
            if (this.highlightId) {
                if (item.variantId) {
                    return (this.getConcatenatedString(item.variantId, item.productInventoryType) == this.highlightId);
                }
                else {
                    return (this.getConcatenatedString(item.id, item.productInventoryType) == this.highlightId);
                }
            }
            return false;
        }
        getConcatenatedString(id, type: string): string {
            return id + '_' + type;
        }
        openAuditModal = () => {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/components/auditHistory/auditHistory.html",
                locals: {
                    auditLog: this.auditHistory,
                    userId: this.identityService.current().userId,
                    userName: this.identityService.current().userAuthName
                },
                controller: "meevo.auditHistory.AuditHistoryController",
                controllerAs: "auditHistory",
                bindToController: true
            }
            this.modalService.showCustom(options);
        }

        showAuditHistory = (id) => {          
            let request = {
                asLocationId: this.isCo? null: this.identityService.locationId,
                itemsPerPage: 30,
                pageNumber: 0,
                criteria: {
                    entityId: id,
                    startDate: moment().subtract(2, "years").toDate(),
                    endDate: moment().toDate(),
                    purpose: Meevo.Model.PurposeEnum.Audit,
                    nounId: this.viewNotes ? Meevo.Model.NounEnum.InventoryTransferNote : Meevo.Model.NounEnum.InventoryTransfer,
                }
            }
            return this.dataService.customMethodData("api/ActivityLog/DataChange/List/", "post", request).then((res) => {
                this.auditHistory = res.data;
            })
        }

        // -----------------------------------------------------------------------------
        // Lot tracking (FA8 Inventory Transfer Lot Modal — ADO 117621)
        //
        // For variants with `trackLots`, the Transfer Out grid swaps the qty
        // spinner for a pencil (editable) / eye (post-transfer) icon that opens
        // the <meevo-lot-tracking-modal> web component via LotModalBridge. The
        // same modal in readonly mode is reused from the Receive screen via the
        // eye icon next to Qty Transferred.
        //
        // No client-side `_pending` flag (unlike PO Receive): transfers commit
        // allocations atomically with Save / Transfer Out — every modal Apply
        // overwrites lineItem.lotAllocations wholesale, and the next server
        // refresh re-hydrates from RS4 of usp_Transfer_Get.
        // -----------------------------------------------------------------------------

        /** True for transfers that have moved past the Saved status — the line
         *  is committed and lot allocations are no longer editable. Drives the
         *  pencil-vs-eye icon choice in the grid template. */
        public isPostTransferOut(item?: Meevo.Model.InventoryTransferLineItem): boolean {
            if (!this.inventoryTransfer) return false;
            // transferStatusBW values (per TransferStatusEnum): 0=None, 1=Saved,
            // 2=Deleted, 4=Transferred, 8=Returned, 16=Recalled, 32=Received.
            // Only Transferred / Returned / Received are "committed and
            // immutable" states; None/Saved are pre-commit and Deleted/Recalled
            // produce a draft when re-opened so allocations remain editable.
            var s = this.inventoryTransfer.transferStatusBW;
            return s === Meevo.Model.TransferStatusEnum.Transferred
                || s === Meevo.Model.TransferStatusEnum.Returned
                || s === Meevo.Model.TransferStatusEnum.Received;
        }

        /** Issue 6 (FA8): the lot icon is the only affordance for inspecting
         *  per-lot allocations from the grid, so the eye (post-transfer
         *  readonly) path must stay clickable even when the form is in
         *  readonly mode. Only the pencil (pre-commit edit) path is gated
         *  by `isReadonly()`. Without this split the eye was unclickable
         *  until the user clicked Edit, which defeated the whole "view
         *  lots from a committed transfer" affordance. Used by both
         *  ng-class/ng-style (visual disabled state) and ng-click
         *  (action gate) bindings in index.html. */
        public isLotIconClickable(item: Meevo.Model.InventoryTransferLineItem): boolean {
            if (!item || !item.trackLots) return false;
            return !this.isReadonly() || this.isPostTransferOut(item);
        }

        public lotIconAriaLabel(item: Meevo.Model.InventoryTransferLineItem): string {
            if (!item || !item.trackLots) return '';
            if (this.isReadonly() || this.isPostTransferOut(item)) {
                return this.$translate.instant('LABEL_VIEW_LOTS');
            }
            var hasAllocations = item.lotAllocations && item.lotAllocations.length > 0;
            return this.$translate.instant(hasAllocations ? 'LABEL_EDIT_LOTS' : 'LABEL_ENTER_LOTS');
        }

        /** Opens the lot allocation modal for the Transfer Out screen. The mode
         *  is derived from grid state: any non-Saved status (post-transfer) or
         *  the form being in readonly view mode forces 'readonly'; otherwise the
         *  modal opens in 'editable'. */
        public openLotAllocationModal(item: Meevo.Model.InventoryTransferLineItem): void {
            if (!item || !item.trackLots) return;
            if (!this.lotModalBridge) return;
            // Empty/missing variant id degrades the typeahead's per-variant
            // filter to "match anything" — bail before opening the modal so
            // we never present an unscoped lot list. The grid normally
            // populates item.id from the variant search, but defensive code
            // here matches the receive-side guard below.
            if (!item.id) return;

            var mode: 'editable' | 'readonly' =
                (this.isReadonly() || this.isPostTransferOut(item)) ? 'readonly' : 'editable';

            var fromLocationId =
                (this.inventoryTransfer && this.inventoryTransfer.transferringLocationId)
                || this.productSearchCriteria.transferringLocationId
                || this.currentLocationId;

            var lineItem: Meevo.Plugins.InventoryTransfer.ILotModalInput = {
                context: 'inventory-transfer',
                // TS 2.3 in this host shell predates the `?.` / `??` operators.
                // The early guard above (`if (!item.id) return`) means item.id is
                // truthy here, so the legacy ternary is equivalent.
                variantId: item.id ? item.id.toString() : '',
                productInventoryTypeEnum: item.productInventoryType,
                fromLocationId: fromLocationId,
                productDisplayName: item.productDisplayName || '',
                variantDisplayName: item.displayName || '',
                sku: item.sku,
                barCode: item.barCode || '',
                inventoryTypeDisplay: this.$translate.instant('ENUM_LABEL_' + item.productInventoryType),
                trackExpirationDate: !!item.trackExpirationDate,
                transferQuantity: item.transferQuantity || 0,
                autofillSuggestedQty: item.autofillSuggestedQty,
                isReceiveView: false,
            };

            var existingAllocations: Meevo.Plugins.InventoryTransfer.ILotAllocation[] =
                (item.lotAllocations || []).slice();

            this.lotModalBridge.open(
                lineItem,
                existingAllocations,
                mode,
                (newAllocations) => {
                    // Atomic-commit contract: the WC emits the full editable set;
                    // overwrite the line's allocations wholesale. transferQuantity
                    // becomes the sum; save() recomputes again as a guard.
                    item.lotAllocations = (newAllocations || []).slice();
                    item.transferQuantity = item.lotAllocations.reduce(
                        (sum: number, a) => sum + (a.quantity || 0), 0);
                    item.lineTotal = this.calculateLineTotal(item);
                    // Clear the Autofill hint once the user has acted on it.
                    item.autofillSuggestedQty = undefined;
                },
                () => { /* cancelled — no state change */ },
            );
        }

        /** Opens the lot allocation modal from the Receive screen in readonly
         *  mode. The subtitle is swapped to "Qty Transferred: {N}" by the WC
         *  using the isReceiveView discriminator. */
        public openReceiveLotModal(item: Meevo.Model.InventoryTransferLineItem): void {
            if (!item || !item.trackLots) return;
            if (!this.lotModalBridge) return;
            // Same guard as openLotAllocationModal — see comment there.
            if (!item.id) return;

            var fromLocationId =
                (this.inventoryTransfer && this.inventoryTransfer.transferringLocationId)
                || this.productSearchCriteria.transferringLocationId
                || this.currentLocationId;

            var lineItem: Meevo.Plugins.InventoryTransfer.ILotModalInput = {
                context: 'inventory-transfer',
                // Same legacy-TS adjustment as openLotAllocationModal; the guard
                // above (`if (!item.id) return`) keeps item.id truthy here.
                variantId: item.id ? item.id.toString() : '',
                productInventoryTypeEnum: item.productInventoryType,
                fromLocationId: fromLocationId,
                productDisplayName: item.productDisplayName || '',
                variantDisplayName: item.displayName || '',
                sku: item.sku,
                barCode: item.barCode || '',
                inventoryTypeDisplay: this.$translate.instant('ENUM_LABEL_' + item.productInventoryType),
                trackExpirationDate: !!item.trackExpirationDate,
                transferQuantity: item.transferQuantity || 0,
                isReceiveView: true,
            };

            var existingAllocations: Meevo.Plugins.InventoryTransfer.ILotAllocation[] =
                (item.lotAllocations || []).slice();

            this.lotModalBridge.open(
                lineItem,
                existingAllocations,
                'readonly',
                undefined,
                () => { /* cancelled / closed */ },
            );
        }

        getDecimalPrecision(item: Meevo.Model.InventoryTransferLineItem, isReceivalOnHand: boolean = false): number {
            if (item
                && ((!isReceivalOnHand && !Number.isInteger(item.onHand))
                    || (isReceivalOnHand && !Number.isInteger(item.receivingLocationOnHand))
                    || (this.tenantEnableProductUsageTracking
                        && item.enableProductUsageTracking
                        && item.productUsageType == Meevo.Model.ProductUsageAmountTypeEnum.PartialAmount))) {
				return this.decimalPrecision;
			}
			return null;
        }
    }
}
